module.exports = __webpack_public_path__ + "static/media/icon-replay.857672f3.svg";